import React from 'react';

// Clean minimal line-drawing SVGs in teal, consistent with ocean-intelligence aesthetic
const iconProps = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" };

// Foundation — seedling
const SeedlingIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M12 22V10" />
    <path d="M6 12c0-4 2.7-6 6-6 3.3 0 6 2 6 6" />
    <path d="M12 10c-3 0-5.5-1.5-6.5-4C6.5 3 9 2 12 2s5.5 1 6.5 4C17.5 8.5 15 10 12 10z" />
  </svg>
);

// NGO — globe with leaf
const GlobeLeafIcon = (props) => (
  <svg {...iconProps} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3c2.5 2.5 4 5.5 4 9s-1.5 6.5-4 9c-2.5-2.5-4-5.5-4-9s1.5-6.5 4-9z" />
    <path d="M16 4c1.5 1 2.5 3 2 5-1.5.5-3-.5-3.5-2" />
  </svg>
);

// Technology — circuit node
const CircuitIcon = (props) => (
  <svg {...iconProps} {...props}>
    <circle cx="12" cy="12" r="2" />
    <circle cx="5" cy="6" r="1.5" />
    <circle cx="19" cy="6" r="1.5" />
    <circle cx="5" cy="18" r="1.5" />
    <circle cx="19" cy="18" r="1.5" />
    <path d="M10.5 10.5L6.5 7.5" />
    <path d="M13.5 10.5l4-3" />
    <path d="M10.5 13.5L6.5 16.5" />
    <path d="M13.5 13.5l4 3" />
  </svg>
);

// Individual — person outline
const PersonIcon = (props) => (
  <svg {...iconProps} {...props}>
    <circle cx="12" cy="7" r="4" />
    <path d="M5.5 21c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5" />
  </svg>
);

// Distributor — play button / film reel
const FilmPlayIcon = (props) => (
  <svg {...iconProps} {...props}>
    <circle cx="12" cy="12" r="9" />
    <polygon points="10,8 17,12 10,16" fill="currentColor" stroke="none" opacity="0.3" />
    <polygon points="10,8 17,12 10,16" />
  </svg>
);

// Conference / Summit — microphone
const MicrophoneIcon = (props) => (
  <svg {...iconProps} {...props}>
    <rect x="9" y="2" width="6" height="10" rx="3" />
    <path d="M5 10c0 3.9 3.1 7 7 7s7-3.1 7-7" />
    <path d="M12 17v4" />
    <path d="M8 21h8" />
  </svg>
);

// Workshop — pencil/tools
const ToolsIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);

// Grant / Challenge Prize — trophy
const TrophyIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M6 9H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3" />
    <path d="M18 9h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-3" />
    <path d="M6 3h12v6c0 3.3-2.7 6-6 6s-6-2.7-6-6V3z" />
    <path d="M12 15v3" />
    <path d="M8 21h8" />
    <path d="M8 21a1 1 0 0 1 0-3h8a1 1 0 0 1 0 3" />
  </svg>
);

// Screening — cinema screen
const ScreenIcon = (props) => (
  <svg {...iconProps} {...props}>
    <rect x="2" y="3" width="20" height="13" rx="2" />
    <path d="M8 21l4-5 4 5" />
    <path d="M9 9l3 2 3-2" />
  </svg>
);

// Brand — diamond
const DiamondIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M6 3h12l4 6-10 12L2 9z" />
    <path d="M2 9h20" />
    <path d="M10 3l-2 6 4 12 4-12-2-6" />
  </svg>
);

// Consultancy — compass
const CompassIcon = (props) => (
  <svg {...iconProps} {...props}>
    <circle cx="12" cy="12" r="9" />
    <polygon points="16.24,7.76 14.12,14.12 7.76,16.24 9.88,9.88" />
  </svg>
);

// Research Institution — microscope
const MicroscopeIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M6 18h8" />
    <path d="M3 22h18" />
    <path d="M14 22a7 7 0 1 0-3-13.3" />
    <path d="M9 14h1" />
    <path d="M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2z" />
    <path d="M12 6V3" />
  </svg>
);

// Broadcaster — signal/antenna
const BroadcasterIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M4.9 19.1A16.3 16.3 0 0 1 2 12c0-3.2 1-6.2 2.9-8.6" />
    <path d="M7.8 16.2A11 11 0 0 1 5 12c0-2 .6-3.9 1.7-5.5" />
    <circle cx="12" cy="12" r="2" />
    <path d="M16.2 7.8A11 11 0 0 1 19 12c0 2-.6 3.9-1.7 5.5" />
    <path d="M19.1 4.9A16.3 16.3 0 0 1 22 12c0 3.2-1 6.2-2.9 8.6" />
  </svg>
);

// Default — generic org
const OrgIcon = (props) => (
  <svg {...iconProps} {...props}>
    <rect x="3" y="8" width="18" height="13" rx="1" />
    <path d="M7 8V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3" />
    <path d="M12 12v4" />
    <path d="M3 12h18" />
  </svg>
);

const TYPE_ICON_MAP = {
  'foundation': SeedlingIcon,
  'ngo': GlobeLeafIcon,
  'technology': CircuitIcon,
  'tech platform': CircuitIcon,
  'tech': CircuitIcon,
  'individual': PersonIcon,
  'distributor': FilmPlayIcon,
  'conference': MicrophoneIcon,
  'summit': MicrophoneIcon,
  'panel': MicrophoneIcon,
  'workshop': ToolsIcon,
  'grant': TrophyIcon,
  'challenge prize': TrophyIcon,
  'screening': ScreenIcon,
  'brand': DiamondIcon,
  'consultancy': CompassIcon,
  'consulting': CompassIcon,
  'research institution': MicroscopeIcon,
  'research': MicroscopeIcon,
  'broadcaster': BroadcasterIcon,
  'unknown': OrgIcon,
};

export const getCategoryIcon = (type) => {
  if (!type) return OrgIcon;
  const normalised = type.toLowerCase().trim();
  return TYPE_ICON_MAP[normalised] || OrgIcon;
};

export default getCategoryIcon;
